export default "__VITE_ASSET__FnnBU2Rm__"